const IF = require( "infrontjs" );

import { InAppState } from "../base/InAppState";

import template from './PremiumTemplate.html';

export class PremiumState extends InAppState
{
    static ROUTE = '/premium';
    static ID = 'premium';

    canEnter()
    {
        const superResult = super.canEnter();
        if ( true === superResult && false === this.app.isNativeMobile() )
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    async enter()
    {
        let paymentData = null,
            userPaymentInfo = null;
        const pdRes = await this.app.api.get( '/payment/data' );
        if ( !pdRes || 200 !== pdRes.status )
        {
            throw new Error( 'Invalid response.' );
        }
        paymentData = await pdRes.json();

        const upi = await this.app.api.get( '/payment/user' );
        if ( !upi || 200 !== upi.status )
        {
            throw new Error( 'Invalid response 2' );
        }
        userPaymentInfo = await upi.json();

        /*
        const ppScript = document.createElement( 'script' );
        ppScript.src = "https://www.paypal.com/sdk/js?client-id=AcKULT9SOW8Pq3VPILFv4mJx3XCIjxe1TMXQZcLbgNPQR7hObm9BGcy_MhRvJkkgqf0TFmMlyPe6qdr9&vault=true&intent=subscription";
        ppScript.setAttribute( "data-sdk-integration-source", "button-factory" );
        ppScript.addEventListener( "load", () =>
        {
            // Remove prices which should not be visible
            paymentData.prices.membership.splice( 3, 2 );

            let currentMotivationPlanId = userPaymentInfo.motivationBonus.planId,
                currentMembershipPlanId = userPaymentInfo.membership.planId;

            const motivationPlans = paymentData.prices.motivation.filter(  p => p.planId !== currentMotivationPlanId );
            const membershipPlans = paymentData.prices.membership.filter( p => p.planId !== currentMembershipPlanId );

            const currentMotivationPlan = paymentData.prices.motivation.filter(  p => p.planId === currentMotivationPlanId );
            const currentMembershipPlan = paymentData.prices.membership.filter(  p => p.planId === currentMembershipPlanId );

            this.app.container.innerHTML = this.app.view.getHtml(
                template,
                {
                    motivationPlans : motivationPlans,
                    membershipPlans : membershipPlans,
                    currentMembershipPlan : currentMembershipPlan && currentMembershipPlan.length > 0 ? currentMembershipPlan[ 0 ] : null,
                    currentMotivationPlan : currentMotivationPlan && currentMotivationPlan.length > 0 ? currentMotivationPlan[ 0 ] : null,
                    currentUser : this.app.currentUser
                }
            );

            const self = this;


            window.paypal
                .Buttons({
                    style: {
                        shape: 'pill',
                        color: 'gold',
                        layout: 'vertical',
                        label: 'subscribe'
                    },
                    async createSubscription( data, actions ) {
                        return actions.subscription.revise(
                            userPaymentInfo.membership.subscriptionId,
                            {
                                "plan_id" : self.app.container.querySelector( '[data-id="newMembershipPlanId"]' ).value
                            }
                        );
                    },
                    async onApprove( data ) {
                        await self.app.api.patch( '/payment/subscription/membership' );
                        self.app.router.redirect( '/' );
                        self.app.gui.showSnackbarConfirmed( 'Mitgliedschaft Abo erfolgreich aktualisert.' );
                    },
                })
                .render("#paypal-button-container-membership");

            window.paypal
                .Buttons({
                    style: {
                        shape: 'pill',
                        color: 'gold',
                        layout: 'vertical',
                        label: 'subscribe'
                    },
                    async createSubscription( data, actions ) {
                        return actions.subscription.revise(
                            userPaymentInfo.motivationBonus.subscriptionId,
                            {
                                "plan_id" : self.app.container.querySelector( '[data-id="newMotivationBonusPlanId"]' ).value
                            }
                        );
                    },
                    async onApprove( data ) {

                        await self.app.api.patch( '/payment/subscription/motivationBonus' );
                        self.app.router.redirect( '/' );
                        self.app.gui.showSnackbarConfirmed( 'Motivationbonus Abo erfolgreich aktualisiert.' );
                    },
                })
                .render("#paypal-button-container-motivation");

        });
        const head = document.head || document.getElementsByTagName('head')[0];
        head.insertBefore( ppScript, head.firstChild);
         */

        // Remove prices which should not be visible
        paymentData.prices.membership = paymentData.prices.membership.slice( 0, 3);

        let currentMotivationPlanId = userPaymentInfo.motivationBonus.planId,
            currentMembershipPlanId = userPaymentInfo.membership.planId;

        const motivationPlans = paymentData.prices.motivation.filter(  p => p.planId !== currentMotivationPlanId );
        const membershipPlans = paymentData.prices.membership.filter( p => p.planId !== currentMembershipPlanId );

        const currentMotivationPlan = paymentData.prices.motivation.filter(  p => p.planId === currentMotivationPlanId );
        const currentMembershipPlan = paymentData.prices.membership.filter(  p => p.planId === currentMembershipPlanId );

        this.app.container.innerHTML = this.app.view.getHtml(
            template,
            {
                motivationPlans : motivationPlans,
                membershipPlans : membershipPlans,
                currentMembershipPlan : currentMembershipPlan && currentMembershipPlan.length > 0 ? currentMembershipPlan[ 0 ] : null,
                currentMotivationPlan : currentMotivationPlan && currentMotivationPlan.length > 0 ? currentMotivationPlan[ 0 ] : null,
                currentUser : this.app.currentUser
            }
        );

        const self = this;


        window.paypal
            .Buttons({
                style: {
                    shape: 'pill',
                    color: 'gold',
                    layout: 'vertical',
                    label: 'subscribe'
                },
                async createSubscription( data, actions ) {
                    return actions.subscription.revise(
                        userPaymentInfo.membership.subscriptionId,
                        {
                            "plan_id" : self.app.container.querySelector( '[data-id="newMembershipPlanId"]' ).value
                        }
                    );
                },
                async onApprove( data ) {
                    await self.app.api.patch( '/payment/subscription/membership' );
                    self.app.router.redirect( '/' );
                    self.app.gui.showSnackbarConfirmed( 'Mitgliedschaft Abo erfolgreich aktualisert.' );
                },
            })
            .render("#paypal-button-container-membership");

        window.paypal
            .Buttons({
                style: {
                    shape: 'pill',
                    color: 'gold',
                    layout: 'vertical',
                    label: 'subscribe'
                },
                async createSubscription( data, actions ) {
                    return actions.subscription.revise(
                        userPaymentInfo.motivationBonus.subscriptionId,
                        {
                            "plan_id" : self.app.container.querySelector( '[data-id="newMotivationBonusPlanId"]' ).value
                        }
                    );
                },
                async onApprove( data ) {

                    await self.app.api.patch( '/payment/subscription/motivationBonus' );
                    self.app.router.redirect( '/' );
                    self.app.gui.showSnackbarConfirmed( 'Motivationbonus Abo erfolgreich aktualisiert.' );
                },
            })
            .render("#paypal-button-container-motivation");


    }

    async exit()
    {

    }
};
